<template>
  <div class="addpersonnel">
    <el-form ref="ruleForm" :model="ruleForm" class="ruleForm" :rules="rules" label-width="120px">
      <div class="people">
        <div class="picture">
          <el-upload
            :action="uploadUrl"
            :show-file-list="false"
            :data="token"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <div class="imgBox">
              <img v-if="personPhoto" :src="personPhoto" />
              <i v-if="!personPhoto" class="el-icon-plus avatar-uploader-icon"></i>
            </div>
          </el-upload>
        </div>
        <div class="peopleInformation">
          <el-row>
            <el-col :span="10">
              <el-form-item label="人员标识号" prop="personNo" style="z-index: 1">
                <el-input v-model="ruleForm.personNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="性别">
                <el-select v-model="ruleForm.personSex" clearable filterable>
                  <el-option label="男" value="1"></el-option>
                  <el-option label="女" value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item label="姓名" prop="personName">
                <el-input v-model="ruleForm.personName" clearable maxlength="32"></el-input>
              </el-form-item>
            </el-col>
            <el-tooltip
              :disabled="!ruleForm.oaId"
              class="item"
              effect="dark"
              :content="String(ruleForm.oaId)"
              placement="top"
            >
              <el-col :span="8">
                <el-form-item label="OAID" prop="oaId">
                  <el-input v-model="ruleForm.oaId" clearable maxlength="32"></el-input>
                </el-form-item>
              </el-col>
            </el-tooltip>
          </el-row>
        </div>
      </div>
      <div class="common-tab tab">
        <el-tabs v-model="activeName" type="border-card">
          <el-tab-pane :label="$t('personnel.addpersonnel.companyInformation')" name="first">
            <div class="tabArea">
              <table-Compent class="TableCompent" ref="TableCompent"></table-Compent>
              <div style="margin-top: 10px">
                <el-row>
                  <el-col :span="24">
                    <div class="companytitle">{{ $t('personnel.addpersonnel.phoneWays') }}</div>
                  </el-col>
                </el-row>
                <el-row class="callWays">
                  <el-col :span="24">
                    <div style="float: left">
                      <el-form-item
                        :label="$t('personnel.table.phone')"
                        prop="personMobilePhone"
                        label-width="120px"
                      >
                        <el-tooltip
                          :disabled="!ruleForm.personMobilePhone"
                          class="item"
                          effect="dark"
                          :content="ruleForm.personMobilePhone"
                          placement="top"
                        >
                          <el-input
                            v-model="ruleForm.personMobilePhone"
                            clearable
                            maxlength="32"
                          ></el-input>
                        </el-tooltip>
                      </el-form-item>
                    </div>
                    <div style="float: left">
                      <el-form-item
                        :label="$t('personnel.addpersonnel.email')"
                        prop="personEmail"
                        label-width="120px"
                      >
                        <el-tooltip
                          :disabled="!ruleForm.personEmail"
                          class="item"
                          effect="dark"
                          :content="ruleForm.personEmail"
                          placement="top"
                        >
                          <el-input
                            v-model="ruleForm.personEmail"
                            clearable
                            maxlength="32"
                          ></el-input>
                        </el-tooltip>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('personnel.addpersonnel.adminInformation')" name="second">
            <div class="tabArea">
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="selfInformation">
                    <el-form-item
                      :label="$t('personnel.addpersonnel.personNational')"
                      prop="personNational"
                      label-width="120px"
                    >
                      <el-select
                        v-model="ruleForm.personNational"
                        clearable
                        filterable
                        @change="personNationalChange()"
                        class="personNational"
                        :placeholder="$t('personnel.addpersonnel.changeTitle')"
                      >
                        <el-option
                          :label="item.label"
                          :value="item.value"
                          v-for="(item, index) in nationalityList"
                          :key="index"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="selfInformation">
                    <el-form-item
                      :label="$t('personnel.addpersonnel.personId')"
                      prop="personId"
                      label-width="120px"
                    >
                      <el-tooltip
                        :disabled="!ruleForm.personId"
                        class="item"
                        effect="dark"
                        :content="ruleForm.personId"
                        placement="top"
                      >
                        <el-input
                          :placeholder="$t('personnel.addpersonnel.inputTitle')"
                          v-model="ruleForm.personId"
                          @blur="personIdRespt"
                          clearable
                          maxlength="32"
                        ></el-input>
                      </el-tooltip>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="selfInformation">
                    <el-form-item
                      :label="$t('personnel.addpersonnel.passportId')"
                      prop="passportId"
                      label-width="120px"
                    >
                      <el-tooltip
                        :disabled="!ruleForm.passportId"
                        class="item"
                        effect="dark"
                        :content="ruleForm.passportId"
                        placement="top"
                      >
                        <el-input v-model="ruleForm.passportId" clearable maxlength="32"></el-input>
                      </el-tooltip>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div></div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div class="companytitle top">{{
                    $t('personnel.addpersonnel.bankInformation')
                  }}</div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="selfInformation">
                    <el-form-item
                      :label="$t('personnel.addpersonnel.personBankAccount')"
                      prop="personBankAccount"
                      label-width="120px"
                    >
                      <el-tooltip
                        :disabled="!ruleForm.personBankAccount"
                        class="item"
                        effect="dark"
                        :content="ruleForm.personBankAccount"
                        placement="top"
                      >
                        <el-input
                          v-model="ruleForm.personBankAccount"
                          clearable
                          maxlength="32"
                        ></el-input>
                      </el-tooltip>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="selfInformation">
                    <el-form-item
                      :label="$t('personnel.addpersonnel.personDepositBank')"
                      prop="personDepositBank"
                      label-width="120px"
                    >
                      <el-tooltip
                        :disabled="!ruleForm.personDepositBank"
                        class="item"
                        effect="dark"
                        :content="ruleForm.personDepositBank"
                        placement="top"
                      >
                        <el-input
                          v-model="ruleForm.personDepositBank"
                          clearable
                          maxlength="32"
                        ></el-input>
                      </el-tooltip>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="selfInformation">
                    <el-form-item
                      :label="$t('personnel.addpersonnel.personAccountName')"
                      prop="personAccountName"
                      label-width="120px"
                    >
                      <el-tooltip
                        :disabled="!ruleForm.personAccountName"
                        class="item"
                        effect="dark"
                        :content="ruleForm.personAccountName"
                        placement="top"
                      >
                        <el-input
                          v-model="ruleForm.personAccountName"
                          clearable
                          maxlength="32"
                        ></el-input>
                      </el-tooltip>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="selfInformation">
                    <el-form-item
                      :label="$t('personnel.addpersonnel.personBankReservation')"
                      prop="personBankReservation"
                      label-width="120px"
                    >
                      <el-tooltip
                        :disabled="!ruleForm.personBankReservation"
                        class="item"
                        effect="dark"
                        :content="ruleForm.personBankReservation"
                        placement="top"
                      >
                        <el-input
                          v-model="ruleForm.personBankReservation"
                          clearable
                          maxlength="32"
                        ></el-input>
                      </el-tooltip>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    <el-form-item
                      :label="$t('personnel.addpersonnel.bankCardFrontPhotos')"
                      prop="bankCardFrontPhotos"
                      label-width="120px"
                    >
                      <div class="idCard">
                        <!-- <img :src="ruleForm.bankCardBack" /> -->
                        <el-upload
                          class="avatar-uploader"
                          :action="uploadUrl"
                          :data="token"
                          :show-file-list="false"
                          :file-list="ruleForm.bankCardFrontPhotos"
                          :on-success="bankCardFrontSuccess"
                          :before-upload="beforeAvatarUpload"
                        >
                          <div class="bankCardFrontBox">
                            <img v-if="idCardFrontPhoto" :src="idCardFrontPhoto" class="avatar" />
                            <i
                              v-if="!idCardFrontPhoto"
                              class="el-icon-plus avatar-uploader-icon"
                            ></i>
                          </div>
                        </el-upload>
                      </div>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple-light">
                    <el-form-item
                      :label="$t('personnel.addpersonnel.bankCardBackPhotos')"
                      prop="bankCardBackPhotos"
                      label-width="120px"
                    >
                      <div class="idCard">
                        <el-upload
                          class="avatar-uploader"
                          :action="uploadUrl"
                          :data="token"
                          :show-file-list="false"
                          :file-list="ruleForm.bankCardBackPhotos"
                          :on-success="bankCardBackSuccess"
                          :before-upload="beforeAvatarUpload"
                        >
                          <div class="bankCardFrontBox">
                            <img v-if="idCardBackPhoto" :src="idCardBackPhoto" class="avatar" />
                            <i
                              v-if="!idCardBackPhoto"
                              class="el-icon-plus avatar-uploader-icon"
                            ></i>
                          </div>
                        </el-upload>
                      </div>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('personnel.addpersonnel.pushMapLinkList')" name="third">
            <div class="tabArea">
              <vxe-toolbar>
                <template v-slot:buttons>
                  <vxe-button size="medium" class="vxe-btn-primary" style="color: white">{{
                    $t('personnel.addpersonnel.pushMapLink')
                  }}</vxe-button>
                </template>
              </vxe-toolbar>
              <sirui-table ref="siruiTable" :loading="load" :data="tableData" :paging="false">
                <vxe-table-column
                  v-for="(item, index) in columnList"
                  :key="index"
                  :width="item.width"
                  :field="item.prop"
                  :title="item.label"
                ></vxe-table-column>
              </sirui-table>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-form>
    <div class="fixed-bottom-btnList">
      <el-button
        v-hasPermi="['2021050815460168375']"
        type="primary"
        class="fixed-bottom-btn"
        @click="save('ruleForm', 0)"
        :loading="loading"
        >{{ $t('personnel.addpersonnel.save') }}</el-button
      >
      <el-button
        v-hasPermi="['2021050815461507105']"
        type="primary"
        class="fixed-bottom-btn"
        :loading="loading"
        @click="sumbit('ruleForm', 1)"
        >{{ $t('personnel.addpersonnel.sumbit') }}</el-button
      >
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import SiruiTable from '@/components/SiruiTable';
  import tableCompent from '../personnel/components/tableCompent';
  import API from '@/api/masterData/personnel';
  import baseUrl from '@/common/config';
  export default {
    name: 'addpersonnel',
    components: {
      SiruiTable,
      tableCompent,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,

        //获取国籍
        nationalityList(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'person_national').dictList;
          }
        },
      }),
      adminFlag() {
        return this.userInfo.userInfo.adminFlag;
      },
      columnList() {
        return [
          {
            prop: 'middleClass',
            label: this.$t('personnel.addpersonnel.middleClass'),
          },
          {
            prop: 'middleClassValue',
            label: this.$t('personnel.addpersonnel.middleClass'),
          },
          {
            prop: 'mappingSystem',
            label: this.$t('personnel.addpersonnel.middleClass'),
          },
          {
            prop: 'mappingClass',
            label: this.$t('personnel.addpersonnel.middleClass'),
          },
          {
            prop: 'mappingClassValue',
            label: this.$t('personnel.addpersonnel.middleClass'),
          },
        ];
      },
      token() {
        return {
          access_token: this.userInfo.userInfo.access_token,
        };
      },
      uploadUrl() {
        return baseUrl + API.PERSONNEL_UPLOADSHOW;
      },
    },
    data() {
      //校验电子邮箱
      var checkEmail = (rule, value, callback) => {
        let reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
        if (!reg.test(value)) {
          callback(new Error(this.$t('personnel.rules.emailChecked')));
        } else {
          callback();
        }
      };
      //校验移动电话
      var checkPhone = (rule, value, callback) => {
        let arr = value.split(';');
        if (arr[arr.length - 1] == '') {
          arr = arr.slice(0, arr.length - 1);
        }
        let reg = /^1[3456789]\d{9}$/;
        let flag = false;
        arr.forEach((item) => {
          if (!reg.test(item)) {
            flag = true;
          }
        });
        if (flag) {
          callback(new Error(this.$t('personnel.rules.phoneChecked')));
        } else {
          callback();
        }
      };
      //校验银行预留电话手机号和固话
      // var checkPhoneBank = (rule, value, callback) => {
      //   let reg = /(^[0-9]{3,4}\-[0-9]{7,8}$)|(^[0-9]{3,8}$)|(^1[3456789]\d{9}$)/;
      //   if (!reg.test(value)) {
      //     callback(new Error(this.$t('personnel.rules.checkPhoneBank')));
      //   } else {
      //     callback();
      //   }
      // };
      //校验护照
      var checkIdpassportNo = (rule, value, callback) => {
        if (value.length === 0) {
          callback();
        } else {
          let reg =
            /^1[45][0-9]{7}$|([P|p|S|s]\d{7}$)|([S|s|G|g]\d{8}$)|([Gg|Tt|Ss|Ll|Qq|Dd|Aa|Ff]\d{8}$)|([H|h|M|m]\d{8,10})$/;
          if (!reg.test(value)) {
            callback(new Error(this.$t('personnel.rules.checkIdpassportNo')));
          } else {
            callback();
          }
        }
      };
      //校验银行账号
      var checkBankAccount = (rule, value, callback) => {
        let valList = [...value].reverse();
        let sum = 0; //存储每一位计算结果的和
        let jishu = [];
        let oushu = [];
        valList.forEach((item, index) => {
          if (parseInt((index + 1) % 2) == 1) {
            jishu.push(Number(item));
          } else {
            let n = Number(item * 2);
            if (n < 10) {
              oushu.push(Number(n));
            } else {
              let gewei = Number(n) % 10;
              oushu.push(gewei + 1);
            }
          }
        });
        jishu = jishu.concat(oushu);
        jishu.forEach((item) => {
          sum = sum + item;
        });
        if (sum % 10 != 0) {
          callback(new Error(this.$t('personnel.rules.checkBankAccount')));
        } else {
          callback();
        }
      };
      //校验身份证号
      var checkIdCard = (rule, value, callback) => {
        //18位前17位为数字，最后一位是校验位，可能为数字或字符X
        let reg = /^\d{17}(\d|X|x)$/;
        // let numSit = false; //位数是否符合要求
        if (value.length === 0) {
          callback();
        } else {
          if (!reg.test(value)) {
            callback(new Error(this.$t('personnel.rules.writeIdCardNumber')));
          } else {
            let sumFlag = 0;
            let valList = [...value].reverse();
            valList.forEach((item, index) => {
              if (item == 'x' || item == 'X') {
                sumFlag = sumFlag + 10;
              } else {
                sumFlag = sumFlag + Number(item) * Math.pow(2, index);
              }
            });
            if (sumFlag % 11 === 1) {
              callback();
            } else {
              callback(new Error(this.$t('personnel.rules.checkIdCard')));
            }
          }
        }
      };
      return {
        rules: {
          personNo: [
            {
              required: true,
              message: this.$t('personnel.rules.personNoReason'),
              trigger: ['blur', 'change'],
            },
            // { min: 3, max: 50, message: '名称长度在 3 到 50 个字符' }
          ],
          personName: [
            {
              required: true,
              message: this.$t('personnel.rules.writeName'),
              trigger: ['blur', 'change'],
            },
            // { min: 3, max: 50, message: '名称长度在 3 到 50 个字符' }
          ],
          oaId: [
            {
              required: true,
              message: this.$t('personnel.rules.oaIdReason'),
              trigger: ['blur', 'change'],
            },
            // { min: 3, max: 50, message: '名称长度在 3 到 50 个字符' }
          ],
          personMobilePhone: [
            {
              required: true,
              message: this.$t('personnel.rules.writePhone'),
              trigger: ['blur', 'change'],
            },
            { validator: checkPhone, trigger: ['blur', 'change'] },
          ],
          personEmail: [
            {
              required: true,
              message: this.$t('personnel.rules.writeEamil'),
              trigger: ['blur', 'change'],
            },
            { validator: checkEmail, trigger: ['blur', 'change'] },
          ],
          personNational: [
            {
              required: true,
              message: this.$t('personnel.rules.writeCountry'),
              trigger: 'change',
            },
          ],
          personId: [
            {
              required: true,
              message: this.$t('personnel.rules.writeIdcard'),
              trigger: ['blur', 'change'],
            },
            { validator: checkIdCard, trigger: 'blur' },
          ],
          passportId: [
            {
              required: false,
              message: this.$t('personnel.rules.writePassportNo'),
              trigger: 'blur',
            },
            { validator: checkIdpassportNo, trigger: 'blur' },
          ],
          personBankAccount: [
            {
              required: true,
              message: this.$t('personnel.rules.writeBankAccount'),
              trigger: 'blur',
            },
            { validator: checkBankAccount, trigger: ['blur', 'change'] },
          ],
          personDepositBank: [
            {
              required: true,
              message: this.$t('personnel.rules.writeDepositBank'),
              trigger: ['blur', 'change'],
            },
          ],
          // personAccountName: [
          //   {
          //     required: true,
          //     message: this.$t("personnel.rules.writeAccountName"),
          //     trigger: ["blur", "change"]
          //   }
          // ],
          // personBankReservation: [
          //   {
          //     required: true,
          //     message: this.$t("personnel.rules.writeBankReservation"),
          //     trigger: "blur"
          //   },
          //   { validator: checkPhoneBank, trigger: ["blur", "change"] }
          // ],
          // bankCardFrontPhotos: [
          //   {
          //     required: true,
          //     message: this.$t("personnel.rules.writebankCardFrontPhotos"),
          //     trigger: ["blur", "change"]
          //   }
          // ],
          // bankCardBackPhotos: [
          //   {
          //     required: true,
          //     message: this.$t("personnel.rules.writebankCardFrontPhotos"),
          //     trigger: ["blur", "change"]
          //   }
          // ]
        },
        loading: false,
        identityNoVisible: false,
        idCardFlag: false,
        imageUrl: '',
        load: false,
        tableData: [],
        fileList: [],
        dataStatus: '', //数据状态 保存：ZT06
        personPhoto: '',
        idCardFrontPhoto: '',
        idCardBackPhoto: '',
        oldPersonId: '',
        ruleForm: {
          currentState: '',
          personNo: '', //编号
          personName: '', //姓名
          oaId: '', //人员识别号
          personSex: '1', //性别
          personMobilePhone: '',
          personEmail: '',
          personNational: '', //国籍
          personId: '', //身份证号
          passportId: '', //护照号
          personBankAccount: '', //银行账号
          personDepositBank: '', //开户行
          personAccountName: '', //开户名
          personBankReservation: '', //银行预留电话
          bankCardFrontPhotos: [],
          bankCardBackPhotos: [],
          personCompanyDos: [],
        },
        activeName: 'first',
        partnerData: {},
      };
    },
    mounted() {},
    methods: {
      //国籍
      personNationalChange() {
        if (
          this.ruleForm.personNational == 'CN' ||
          this.ruleForm.personNational == 'MO' ||
          this.ruleForm.personNational == 'HK' ||
          this.ruleForm.personNational == 'ZH'
        ) {
          this.rules.personId[0].required = true;
        } else {
          this.rules.personId[0].required = false;
        }
        //清除中国国籍外对身份证的必填校验提示
        if (this.ruleForm.personNational != 'CN') {
          this.$refs.ruleForm.validateField('personId');
        }
      },
      //跳转
      toList() {
        let pathList = {
          fromPath: {
            path: '/masterData/addpersonnel',
            name: 'addpersonnel',
            meta: {
              keepAlive: true,
              title: this.$t('personnel.addpersonnel.viewPeople'),
            },
          },
          toPath: {
            path: '/masterData/personnel',
            name: 'personnel',
            meta: {
              keepAlive: false,
              title: this.$t('personnel.addpersonnel.personnel'),
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', pathList).then(() => {
          this.$nextTick(() => {
            this.$router.push(pathList.toPath);
          });
        });
      },
      //压缩图片
      dealImage(val, base64, w, callback) {
        var newImage = new Image();
        var quality = 0.1; //压缩系数0-1之间
        newImage.src = base64;
        newImage.setAttribute('crossOrigin', 'Anonymous'); //url为外域时需要
        var imgWidth, imgHeight;
        newImage.onload = function () {
          imgWidth = this.width;
          imgHeight = this.height;
          var canvas = document.createElement('canvas');
          var ctx = canvas.getContext('2d');
          if (Math.max(imgWidth, imgHeight) > w) {
            if (imgWidth > imgHeight) {
              canvas.width = w;
              canvas.height = (w * imgHeight) / imgWidth;
            } else {
              canvas.height = w;
              canvas.width = (w * imgWidth) / imgHeight;
            }
          } else {
            canvas.width = imgWidth;
            canvas.height = imgHeight;
            quality = 0.2;
          }
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(this, 0, 0, canvas.width, canvas.height);
          var base64 = canvas.toDataURL('image/jpeg', quality); //压缩语句
          // 如想确保图片压缩到自己想要的尺寸,如要求在50-150kb之间，请加以下语句，quality初始值根据情况自定
          while (base64.length / 1024 > 150) {
            quality -= 0.01;
            base64 = canvas.toDataURL('image/jpeg', quality);
          }
          // 防止最后一次压缩低于最低尺寸，只要quality递减合理，无需考虑
          while (base64.length / 1024 < 50) {
            quality += 0.001;
            base64 = canvas.toDataURL('image/jpeg', quality);
          }
          callback(val, base64); //必须通过回调函数返回，否则无法及时拿到该值
        };
      },
      printing(val, base64) {
        if (val == 1) {
          this.personPhoto = base64;
        } else if (val == 2) {
          this.bankCardFront = base64;
        } else {
          this.bankCardBack = base64;
        }
      },
      checkId(msg) {
        this.$repeatAlert(
          "<div><img src='./static/img/tips.png'/>" +
            "<div class='repeatContent'>" +
            msg +
            '</div></div>',
          '',
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: this.$t('confirm.repeat'),
            center: true,
            callback: () => {
              let path = {
                path: '/masterData/viewPersonnel',
                name: 'viewPersonnel',
                meta: {
                  keepAlive: true,
                  title: this.$t('personnel.addpersonnel.viewPeople'),
                },
                query: {
                  id: this.partnerData.id,
                  version: this.partnerData.version,
                },
              };
              this.$store.dispatch('tagsView/addTabView', path).then(() => {
                this.$nextTick(() => {
                  this.$router.push(path);
                });
              });
            },
          }
        );
      },
      testIdCard(value) {
        const params = {
          personId: value,
        };
        return new Promise((resolve, reject) => {
          this.$axios
            .post(API.PERSONNEL_CHECKPERSONID, params)
            .then((res) => {
              resolve(res);
            })
            .catch(function (error) {
              reject(error);
            });
        });
      },
      // 判断图片类型
      thinkPicture(val, res, file) {
        if (val == '1') {
          if (file.type === 'image/jpeg') {
            this.personPhoto = 'data:image/jpg;base64,' + res;
          } else {
            this.personPhoto = 'data:image/png;base64,' + res;
          }
        } else if (val == '2') {
          if (file.type === 'image/jpeg') {
            this.idCardFrontPhoto = 'data:image/jpg;base64,' + res;
          } else {
            this.idCardFrontPhoto = 'data:image/png;base64,' + res;
          }
          this.ruleForm.bankCardFrontPhotos = [{ name: '' }];
          this.$refs.ruleForm.validateField('bankCardFrontPhotos');
        } else {
          if (file.type === 'image/jpeg') {
            this.idCardBackPhoto = 'data:image/jpg;base64,' + res;
          } else {
            this.idCardBackPhoto = 'data:image/png;base64,' + res;
          }
          this.ruleForm.bankCardBackPhotos = [{ name: '' }];
          this.$refs.ruleForm.validateField('bankCardBackPhotos');
        }
      },
      //头像
      handleAvatarSuccess(res, file, fileList) {
        this.thinkPicture('1', res, file, fileList);
      },
      //身份证正面
      bankCardFrontSuccess(res, file, fileList) {
        this.thinkPicture('2', res, file, fileList);
      },
      //身份证反面
      bankCardBackSuccess(res, file, fileList) {
        this.thinkPicture('3', res, file, fileList);
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isPNG = file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 1;
        if (!isPNG && !isJPG) {
          this.$message.error(this.$t('personnel.addpersonnel.upLodeTitle'));
        }
        if (!isLt2M) {
          this.$message.error(this.$t('personnel.addpersonnel.upLodeImgSizeTitle'));
        }
        return (isJPG || isPNG) && isLt2M;
      },
      //保存,不需要校验
      save(formName, state) {
        let r = this.$refs.TableCompent;
        if (this.personPhoto) this.dealImage('1', this.personPhoto, 800, this.printing);
        if (this.bankCardFront) this.dealImage('2', this.bankCardFront, 800, this.printing);
        if (this.bankCardBack) this.dealImage('3', this.bankCardBack, 800, this.printing);
        const { tenantCode, companyCode, departmentCode, companyName, departmentName } =
          this.userInfo.userInfo;
        const params = {
          ...this.ruleForm,
          tenantCode,
          companyCode,
          departmentCode,
          companyName,
          departmentName,
        };
        (params.adminFlag = this.adminFlag), (params.buttonType = state);
        r.personCompanyDos.forEach((item) => {
          item.sequenceOrder = Number(item.sequenceOrder);
        });
        params.personCompanyDos = r.personCompanyDos;
        params.personPhoto = this.personPhoto;
        params.bankCardFront = this.idCardFrontPhoto;
        params.bankCardBack = this.idCardBackPhoto;
        params.personCompanyDos = JSON.stringify(params.personCompanyDos);
        params.tenantCode = this.userInfo.userInfo.tenantCode;
        // params.personNo = params.oaId
        this.loading = true;
        this.$axios.post(API.PERSONNEL_SAVEPERSON, params).then((res) => {
          this.loading = false;
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'success',
            });
            if (state == 0) {
              this.dblclickEvent(res.data.data);
            } else {
              this.toList();
            }
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //返回详情
      dblclickEvent(value) {
        let path = {
          fromPath: {
            path: '/masterData/addpersonnel',
            name: 'addpersonnel',
            meta: {
              keepAlive: true,
              title: this.$t('personnel.routerTitle.createPersonnelMaster'),
            },
          },
          toPath: {
            path: '/masterData/editPersonnel',
            name: 'editPersonnel',
            meta: {
              keepAlive: false,
              title: this.$t('personnel.addpersonnel.editPersonnel'),
            },
            query: {
              id: value.id,
              version: value.version,
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      //判断身份证是否重复
      personIdRespt() {
        this.testIdCard(this.ruleForm.personId).then((res) => {
          if (res.data.code == 0) {
            this.partnerData = res.data.data;
            this.activeName = 'second';
            this.checkId(res.data.msg);
          }
        });
      },
      //提交 需要校验
      sumbit(formName, state) {
        let _this = this;
        let tableFlag = this.$refs.TableCompent.deWeight();
        Promise.resolve(this.$refs.TableCompent.fullValidEvent()).then((r) => {
          if (r) {
            this.$refs[formName].validate((valid) => {
              if (valid) {
                _this.testIdCard(this.ruleForm.personId).then((res) => {
                  if (res.data.code == 0) {
                    this.partnerData = res.data.data;
                    this.activeName = 'second';
                    this.checkId(res.data.msg);
                  } else {
                    if (tableFlag) {
                      this.$message({
                        showClose: true,
                        message: this.$t('personnel.routerTitle.companyTheSame'),
                        type: 'error',
                      });
                    } else {
                      this.save(formName, state);
                    }
                  }
                });
              } else {
                this.$message({
                  showClose: true,
                  message: this.$t('personnel.routerTitle.WriteOverPersonInformation'),
                  type: 'error',
                });
              }
            });
          }
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .addpersonnel {
    font-size: 12px;
  }
  .addpersonnel .ruleForm {
    margin-bottom: 40px;
  }
  .addpersonnel .popperStyle {
    color: #fff !important;
    background-color: #ff6b66 !important;
  }
  .addpersonnel .color {
    background-color: rgb(98, 153, 254) !important;
    border: 1px solid rgb(98, 153, 254) !important;
    min-width: 80px;
    border-radius: 2px !important;
  }
  .addpersonnel .plusColor {
    background-color: #6abefd !important;
    border: 1px solid #6abefd !important;
    min-width: 80px;
    border-radius: 2px !important;
  }
  .addpersonnel .popperStyle .popper__arrow::after {
    border-top-color: #ff6b66 !important;
  }
  .addpersonnel .title {
    height: 84px;
    background-color: #fff;
  }
  .addpersonnel .titleChild {
    height: 32px;
    width: 200px;
    padding-top: 26px;
    padding-left: 30px;
  }
  .addpersonnel .people {
    height: 131px;
    background-color: #fff;
    // margin-top: 10px;
    box-sizing: border-box;
    padding-top: 26px;
    padding-left: 30px;
  }
  .addpersonnel .people .el-input--small {
    width: 142px;
  }
  .addpersonnel .selfInformation .el-input--small {
    width: 142px;
  }
  .addpersonnel .top {
    margin: 10px 0;
  }
  .addpersonnel .callWays .el-input--small {
    width: 142px;
  }
  .addpersonnel .people .el-select {
    width: 142px;
  }
  .addpersonnel .people .el-form-item--mini.el-form-item,
  .el-form-item--small.el-form-item {
    margin-bottom: 8px !important;
  }
  .addpersonnel .picture {
    width: 60px;
    height: 79px;
    box-sizing: border-box;
    /* border: 1px solid #c0c4cc; */
    float: left;
  }
  .addpersonnel .picture img {
    width: 60px;
    height: 79px;
    position: absolute;
    left: 0;
  }
  .addpersonnel .imgBox {
    width: 60px;
    height: 79px;
    position: relative;
    border: 1px solid #c0c4cc;
    box-sizing: border-box;
  }
  .addpersonnel .bankCardFrontBox {
    width: 347px;
    height: 173px;
    position: relative;
    border: 1px solid #c0c4cc;
    box-sizing: border-box;
  }
  .addpersonnel .peopleInformation {
    height: 79px;
    width: 800px;
    float: left;
    margin-left: 10px;
    /* background: blue; */
  }
  .addpersonnel .tab {
    margin-top: 10px;
    background-color: #fff;
  }
  .addpersonnel .tabArea {
    box-sizing: border-box;
    padding: 20px;
    padding-top: 10px;
  }
  .addpersonnel .tab .el-tabs__nav-scroll {
    background: #f3f6fa;
  }
  .addpersonnel .companytitle {
    margin-bottom: 10px;
  }
  .addpersonnel .button {
    height: 78px;
    background-color: #fff;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .addpersonnel .buttonList {
    height: 32px;
    margin: auto;
    width: fit-content;
    padding-top: 23px;
  }
  .addpersonnel .buttonStyle {
    border: none;
    width: 102px;
    height: 32px;
  }
  .addpersonnel .idCard {
    width: 347px;
    height: 173px;
    margin-top: 10px;
  }
  .addpersonnel .personNational {
    width: 142px;
  }
  .addpersonnel .idCard img {
    width: 347px;
    height: 173px;
    position: absolute;
    left: 0;
  }
  .addpersonnel .vxe-toolbar {
    padding-top: 0 !important;
  }
  .addpersonnel .TableCompent {
    margin-top: -10px;
  }
  .addpersonnel .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .addpersonnel .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .addpersonnel .avatar-uploader-icon {
    font-size: 28px;
    color: #8dacd6;
    width: 347px;
    height: 173px;
    line-height: 173px;
    text-align: center;
    // border: 1px solid #c0c4cc;
    top: 0px;
    box-sizing: border-box;
    position: absolute;
    left: 0;
    z-index: 1000;
  }
  .addpersonnel .picture .avatar-uploader-icon {
    font-size: 28px;
    color: #8dacd6;
    width: 60px;
    height: 79px;
    line-height: 79px;
    text-align: center;
    z-index: 1;
    position: absolute;
    left: 0;
    top: 0px;
    // border: 1px solid #c0c4cc;
    box-sizing: border-box;
  }
  .addpersonnel .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .common-tab {
    .el-tabs {
      padding: 20px;
      box-sizing: border-box;
    }
    ::v-deep.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
      color: #000000;
    }
    ::v-deep .el-tabs--border-card > .el-tabs__header .el-tabs__item:not(.is-disabled):hover {
      color: #000000;
    }
    ::v-deep .el-tabs__item {
      color: #000000;
    }
  }
</style>
